import axios from 'axios';
import Cookies from 'universal-cookie';
import config from '../../../config';

const cookies = new Cookies();
const BASE_URL = config.API_BASE_URL;

const getAuthHeaders = () => {
  const token = cookies.get('TOKEN');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const unwrap = (payload) => payload?.data ?? payload;

const toArray = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.cuestionarios)) return payload.cuestionarios;
  return [];
};

export async function fetchAllCuestionarios() {
  try {
    const { data } = await axios.get(`${BASE_URL}/cuestionario`, {
      headers: getAuthHeaders(),
    });
    return toArray(data);
  } catch (_error) {
    const { data: pacientes } = await axios.get(`${BASE_URL}/pacientes`, {
      headers: getAuthHeaders(),
    });

    const informes = await Promise.allSettled(
      toArray(pacientes).map((paciente) =>
        axios.get(`${BASE_URL}/pacientes/informes/${paciente.id}`, {
          headers: getAuthHeaders(),
        })
      )
    );

    const cuestionarios = [];
    informes.forEach((result) => {
      if (result.status !== 'fulfilled') return;
      const informe = result.value.data || {};
      const paciente = {
        id: informe.id,
        firstname: informe.firstname,
        lastname: informe.lastname,
      };
      const list = toArray(informe.cuestionario);
      list.forEach((item) => {
        cuestionarios.push({
          ...item,
          paciente,
          pacienteId: item.pacienteId ?? paciente.id,
        });
      });
    });

    return cuestionarios;
  }
}

export async function fetchCuestionarioById(idCuestionario, pacienteId) {
  try {
    const { data } = await axios.get(`${BASE_URL}/cuestionario/${idCuestionario}`, {
      headers: getAuthHeaders(),
    });
    const unwrapped = unwrap(data);
    if (Array.isArray(unwrapped)) {
      const found = unwrapped.find((item) => String(item.id) === String(idCuestionario));
      if (found) return found;
    } else if (unwrapped && String(unwrapped.id) === String(idCuestionario)) {
      return unwrapped;
    }
  } catch (_error) {
    // fallback below
  }

  if (!pacienteId) {
    throw new Error('No se pudo cargar el cuestionario y no hay pacienteId para fallback.');
  }

  const { data } = await axios.get(`${BASE_URL}/pacientes/informes/${pacienteId}`, {
    headers: getAuthHeaders(),
  });
  const informe = data || {};
  const list = toArray(informe.cuestionario);
  const found = list.find((item) => String(item.id) === String(idCuestionario));

  if (!found) {
    throw new Error(`Cuestionario ${idCuestionario} no encontrado para paciente ${pacienteId}.`);
  }

  return {
    ...found,
    paciente: {
      id: informe.id,
      firstname: informe.firstname,
      lastname: informe.lastname,
    },
  };
}
